import React from "react";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/testimonials";
export function TestimonialsSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:py-24" data-id="element-350" data-mp="1rtuyxbmj99ju">
      <div className="mx-auto max-w-6xl" data-id="element-351" data-mp="1mvjniwglaqzi">
        <SectionHeading eyebrow="What Dental Professionals Are Saying" title="Discover How Professionals Are Using This Educational System" data-id="element-352" data-mp="1muia4lc3psem" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-353" data-mp="1dv3ihik77bsj">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-card" data-id="element-354" data-mp="18x243axpw0ne">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-355" data-mp="13zjr99gkx1a4">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-356" data-mp="2ybzx495gqdeg" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4" data-id="element-357" data-mp="1t8lqpr9smrsz">
                <p className="text-lg font-black leading-snug text-ink" data-id="element-358" data-mp="1tbzwl9ho1j56">“{t.headline}”</p>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-muted" data-id="element-359" data-mp="1y6ncijylt585">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-navy-900/10 pt-5" data-id="element-360" data-mp="1oakbjhfhncms">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand/30" data-id="element-361" data-mp="2c0elnr8fan3c" />
                <div className="min-w-0" data-id="element-362" data-mp="2gy6csj18u56h">
                  <p className="font-extrabold text-ink" data-id="element-363" data-mp="2h1an7y5axx5l">{t.name}</p>
                  <p className="text-sm text-ink-muted" data-id="element-364" data-mp="229k0kq6wxtjh">
                    {t.role} · {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="Explore the Complete Blueprint" data-id="element-365" data-mp="2uxo69bphi6m6" />
      </div>
    </section>;
}